var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('div',{staticClass:"col-md-offset-4 col-md-4"},[_c('h1',[_vm._v("Authentification")]),_c('p',[_vm._v("Bienvenu sur MACS GDPR, votre compte est validé !")]),_c('b-button',{attrs:{"varian":"main"},on:{"click":function($event){return _vm.toHome()}}},[_vm._v("Se connecter")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }